// account.service.ts
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiService } from 'app/core/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
    private _apiService = inject(ApiService);
    
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {}

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get current user profile
     */
    getCurrentUser(): Observable<any> {
        return this._apiService.get('/users');
    }

    /**
     * Update admin profile
     */
    updateAdminProfile(profileData: any): Observable<any> {
        return this._apiService.patch('/users', profileData);
    }

    /**
     * Get company details
     */
    getCompany(): Observable<any> {
        return this._apiService.get(`/companies`);
    }

    /**
     * Check if company name exists
     */
    checkCompanyExists(companyName: string): Observable<any> {
        return this._apiService.get(`/companies/name/${companyName}`);
    }

    /**
     * Update company logo
     */
    updateCompanyLogo(logoData: any): Observable<any> {
        return this._apiService.patch('/companies/logo', logoData);
    }

    /**
     * Delete company logo
     */
    deleteCompanyLogo(): Observable<any> {
        return this._apiService.delete('/companies/logo');
    }

    /**
     * Delete the currently authenticated user's account
     */
    deleteAccount(payload: { reason?: string; feedback?: string; acknowledgeDataErasure?: boolean }): Observable<any> {
        const body = payload && Object.values(payload).some((value) => !!value) ? payload : undefined;
        return this._apiService.delete('/users', body);
    }
}